<template>
    <div>
          <!--  Modal Password-->
        <b-modal id="change-password"
            centered
            title="Change account password"
            @ok="updatePassword"
            @cancel="clearDetails"
            :ok-variant="controls.btnColor"
            :ok-disabled="disableOk"
            ok-title="Change Password"
            cancel-variant="link">
            <form>
                <div class="row">
                    <div class="col-sm-12 col-lg-8 offset-lg-2">
                        <!-- New Password -->
                        <div class="form-group">
                            <label for="newPassword">Enter a new password</label>
                            <input class="form-control" type="password" id="password" v-model="formModels.newPassword" />
                            <password-strength :password="formModels.newPassword"></password-strength>
                        </div>
                        <!-- Re-enter New Password -->
                        <div class="form-group">
                            <label for="reEnterNewPassword">Re-enter password</label>
                            <input type="password"
                                name="reEnterNewPassword"
                                v-model="formModels.reEnterNewPassword"
                                v-on:input="$v.formModels.reEnterNewPassword.$touch"
                                class="form-control"
                                autocomplete="off"
                                :class="{'is-invalid': $v.formModels.reEnterNewPassword.$error, 'is-valid': $v.formModels.reEnterNewPassword.$dirty && !$v.formModels.reEnterNewPassword.$invalid}"/>
                                <!-- Validations -->
                                <div v-show="!$v.formModels.reEnterNewPassword.$dirty">
                                        <small class="text-muted">* Required</small>
                                </div><!-- default message -->
                                <div v-if="!$v.formModels.reEnterNewPassword.$invalid && $v.formModels.reEnterNewPassword.$dirty">&nbsp;</div><!-- valid message -->
                                <div v-if="!$v.formModels.reEnterNewPassword.error" class="invalid-feedback">Passwords don't match</div>
                                <div v-else-if="!$v.formModels.reEnterNewPassword.minLength || !$v.formModels.reEnterNewPassword.maxLength" class="invalid-feedback">Must be letters</div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import Vuelidate from 'vuelidate';
import { required, sameAs, minLength} from 'vuelidate/lib/validators';

export default {
    mounted(){
        if(document.getElementById("password")) {
            document.getElementById("password").autocomplete = "off";
            document.getElementById("password").style.backgroundColor = 'transparent';
        }
    },
    data(){
        return{
            controls:{
                btnColor:'success',
            },
            formModels:{
                newPassword:'',
                reEnterNewPassword:'',
            }
        }
    },
    validations:{
        formModels:{
            newPassword:{
                required
            },
            reEnterNewPassword:{
                sameAsPassword: sameAs('newPassword')
            }
        }
    },
    computed:{
        disableOk() {
            if(!this.$v.$invalid) {
                this.controls.btnColor = 'success'
                return false;
            } else {
                this.controls.btnColor = 'light'
                return true;
            }
        },
    },
    methods:{
        updatePassword(){
            this.$emit('password:update', this.formModels.newPassword)
            this.clearDetails()
        },
        clearDetails() {
            this.formModels.newPassword = '';
            this.formModels.reEnterNewPassword = '';
            this.$refs.passwordInstance.password = ''; //reset strength meter
            this.$v.$reset(); //reset vuelidate
        },
        showFeedback ({suggestions, warning}) {
            //console.log('', suggestions)
            //console.log('', warning)
        },
        showScore (score) {
            //console.log('', score)
        },
    }

}
</script>

<style>
.Password {
    max-width:100% !important;
}
</style>
